
import { Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';


import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

import {FormControl} from '@angular/forms';

import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';

 
@Component({
  selector: 'app-formulas',
  templateUrl: './formulas.component.html',
  styleUrls: ['./formulas.component.css']
})

export class FormulasComponent implements OnInit {
 
  checkboxEditDeactivate: any ;
  checkStatus: any ;
  ParamsName: any;

  choicebiIns: any ;


  addOnBlur = false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  setOfElts: any[] = [];
  selectable = true;
  removable = true;

  choosenType = "" ;
  choicebi = "" ;


  formulation = [] ;

  deletionTab = [] ;

  valToAdd = "" ;

  allformulas =[] ;

  @Output() FormulaToReturnBackEvent = new EventEmitter<string>();


  predefini : any ;

  predefinedSetOfElts : any ;

  removablePredef = true;

  fruitCtrl = new FormControl();

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  input:string = "";
  result:string = "";
  
  @Input() allParams: any ;


  selectedParam = "" ;

  baseElement = "" ;

  @Input() title : any  ;
  @Input() formule : any  ;

  saveBtnState = "done_all" ;

  results = [] ;

  registeredresults = [] ;


  ngOnInit(){

    if (this.title=="Energie"){
        this.predefini = true ;
        this.predefinedSetOfElts = ["Essence", "Diesel", "Hybride", "Electrique"] ;
    }
    else
        this.predefini = false ;

    this.choicebi = "calculFormula" ;

    this.formulesToResults(this.formule) ;
  }
 
  pressNum(num: string) {

    if (num==".") {
	    if (this.input !="" ){
	        const lastNum=this.getLastOperand() ;
	        console.log(lastNum.lastIndexOf(".")) ;
	        if (lastNum.lastIndexOf(".") >= 0) 
            return;
	    }
    }
 
    if (num=="0") {
      /*if (this.input=="" ) {
        return;
      }*/
      const PrevKey = this.input[this.input.length - 1];
      if (PrevKey === '/' || PrevKey === '*' || PrevKey === '-' || PrevKey === '+')  {
          return;
      }
    }
    
    this.valToAdd =  this.valToAdd + num ;

    this.input = this.input + num ;
  }
  
  getLastOperand() {
    let pos:number;
    console.log(this.input)
    pos=this.input.toString().lastIndexOf("+") ;
    if (this.input.toString().lastIndexOf("-") > pos) 
      pos=this.input.lastIndexOf("-") ;
    if (this.input.toString().lastIndexOf("*") > pos) 
      pos=this.input.lastIndexOf("*") ;
    if (this.input.toString().lastIndexOf("/") > pos) 
      pos=this.input.lastIndexOf("/");
    console.log('Last '+this.input.substr(pos+1)) ;
    return this.input.substr(pos+1)
  }
 
  pressOperator(op: string) {
     
    if (this.valToAdd!=""){
      this.formulation.push(this.valToAdd);
      this.deletionTab.push(this.valToAdd.length) ;
      this.valToAdd = "" ;
    }

    const lastKey = this.input[this.input.length - 1];

    if (lastKey === '/' || lastKey === '*' || lastKey === '-' || lastKey === '+')  {
      return;
    }
    
    if(op=="min")
      op = " (minoré de) " ;
    if(op=="maj")
      op = " (majoré de) " ;
    if(op=="if")
      op = " Si " ;
    if(op=="supegal")
      op = " ≥ " ;
    if(op=="infegal")
      op = " ≤ " ;
    if(op=="supstrict")
      op = " > " ;
    if(op=="infstrict")
      op = " < " ;

    if(op=="ET")
      op = " ET " ;
    if(op=="OU")
      op = " OU " ;

    if(op=="=")
      op = " = " ;
    if(op=="/")
      op = " / " ;
    if(op=="*")
      op = " * " ;
    if(op=="-")
      op = " - " ;
    if(op=="+")
      op = " + " ;

    if(op=="set"){
      this.choicebi = "SetOfElts" ;
      op="" ;
    }

    if(op=="setRec"){
      this.choicebiIns = "RecParam" ;
      op="" ;
    }

    if(op!=""){
      if(op!="%")
        this.input = this.input + op ;
      else
        this.input = this.input + op ;      
    }

    this.formulation.push(op) ;
    this.deletionTab.push(op.length) ;
  }
 
  clear() {

    if (this.valToAdd!=""){
      if (this.input !="" ) {
        this.input=this.input.substr(0, this.input.length-1) ;
        this.valToAdd=this.valToAdd.substr(0, this.valToAdd.length-1) ;
      }
    }else{
      if (this.input !="" ) { //slice(-1) donne me dernier element du tableau
        if(this.formulation[this.formulation.length-1]=="%"){
          this.input=this.input.substr(0, this.input.length-this.deletionTab[this.deletionTab.length-1]) ;          
        }else
          this.input=this.input.substr(0, this.input.length-this.deletionTab[this.deletionTab.length-1]) ;          

        this.deletionTab.pop();
        this.formulation.pop() ;
      }
    }
  }
 
  allClear() {
    this.result = '';
    this.input = '';
    this.valToAdd = '';
    this.formulation = [] ;
    this.allformulas = [] ;
  }
 
  calcAnswer() {
    let formula = this.input;
 
    let lastKey = formula[formula.length - 1];
 
    if (lastKey === '.')  {
      formula=formula.substr(0,formula.length - 1);
    }
 
    lastKey = formula[formula.length - 1];
 
    if (lastKey === '/' || lastKey === '*' || lastKey === '-' || lastKey === '+' || lastKey === '.')  {
      formula=formula.substr(0,formula.length - 1);
    }
 
    console.log("Formula " +formula);
    this.result = eval(formula);
  }
 
  getAnswer() {

    if(this.input.length!=0)
      this.results.push(this.input) ;

    if(this.choicebiIns=='RecParam'){
      this.allParams= this.allParams.concat(this.setOfElts);
      this.choicebiIns = "" ;      
    }else{

      if (this.valToAdd!=""){
        this.formulation.push(this.valToAdd);
        this.deletionTab.push(this.valToAdd.length) ;
        this.valToAdd = "" ;
      }

      this.allformulas.push(this.formulation) ;
      this.formulation = [] ;
      this.input = "";
    }
  }

  closeEdit(index){
    
    this.results.splice(index, 1) ;
  }

  remRegEdit(index){
    
    this.registeredresults.splice(index, 1) ;
    this.formule.splice(index, 1) ;
  }

  onParamChoosen(event){

    if (event.value!="") {
      this.input = this.input + " (" + event.value.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+ ") " ;
      this.selectedParam = "" ;
      this.formulation.push( event.value.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ) ;
      var inChain = " (" + event.value.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+ ") " ;
      this.deletionTab.push( inChain.length ) ;
    }
  }

  jsonElementFactory(baseElmt, newProp, intitule, type){
    if (baseElmt=="")
      return '{"paramprimName": "'+this.title+'", "params": [{'+'"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": "'+type+'" }]}' ;  
    else
      return baseElmt.substring(0, baseElmt.length-2)+', {"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": "'+type+'" }]}' ;
  }

  saveTypeConfig(){

    if(this.choicebi=='SetOfElts'){
      this.allformulas.push(this.formulation) ;
    }

    if (this.saveBtnState=="done_all"){
      
      for (var i = 0; i < this.allformulas.length; ++i) {
        this.formule.push(this.allformulas[i]) ;
      }

      this.allformulas = this.formule ;

      var stringifiedFormulas = JSON.stringify(this.allformulas) ;
      console.log(stringifiedFormulas);
      this.FormulaToReturnBackEvent.emit(stringifiedFormulas) ;
      this.saveBtnState = "edit" ;  
    }else{
      this.saveBtnState = "done_all" ;      
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.setOfElts.push({"nomFrmt":value.trim()});
    }
    if (input) {
      input.value = '';
    }
  }

  remove(index): void {
    console.log("there we are with "+index) ;
    if (index >= 0) {
      this.setOfElts.splice(index, 1);
    }
  }

  addPredef(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if (this.predefinedSetOfElts.includes(value) && !this.setOfElts.includes(value)) {
      this.setOfElts.push(value);
      this.formulation.push(value) ;
      this.deletionTab.push(value.length) ;

      console.log("The Formulation by now "+JSON.stringify(this.formulation)) ;
    }
    if (input) {
      input.value = '';
    }
    this.fruitCtrl.setValue(null);
  }

  selectedPredef(event: MatAutocompleteSelectedEvent): void {
    if(!this.setOfElts.includes(event.option.viewValue)){
      this.setOfElts.push(event.option.viewValue);
      this.formulation.push(event.option.viewValue) ;

      this.deletionTab.push(event.option.viewValue.length) ;

      console.log("The FOrmulation by now "+JSON.stringify(this.formulation)) ;

      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);      
    }
  }

  removePredef(index): void {
    console.log("there we are with "+index) ;
    if (index >= 0) {
      this.setOfElts.splice(index, 1);
    }
  }

  changeTypeChoice(event){
    this.choosenType = event.value ;
    if(this.choosenType=="Choix multiple")
      this.choicebi='choixmultiple' ;
    if(this.choosenType=="Intervalle")
      this.choicebi='intervalle' ;
    if(this.choosenType=="Calculée")
      this.choicebi='calculee' ;
  }

  formulesToResults(formules){
    for (var i = 0; i< this.formule.length; i++ ) {
     this.registeredresults.push(this.formattFormule(this.formule[i]) ) ;
    }
  }

  formattFormule(formuleArray){
    console.log("*ffff*fff******ff******") ;
    console.log(formuleArray) ;
    var formatted = "" ;
    for (var i = 0; i< formuleArray.length; i++ ) {
      console.log(formuleArray[i]) ;
     if(formuleArray[i]!="%")
       formatted = formatted+formuleArray[i] ;
     else
       formatted = formatted+formuleArray[i] ;
    }
    return formatted ;      
  }

  copyThisArray(arrayToCopy){
    var copyArray = [] ;
    for (var i = 0; i< arrayToCopy.length; i++) {
      copyArray.push(arrayToCopy[i]) ;
    }
    return copyArray ;
  }


  didClick(elt){

    /*if (elt!="") {
      this.input = this.input + " (" + elt.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+ ") " ;
      this.selectedParam = "" ;
      this.formulation.push( elt.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ) ;
      var inChain = " (" + elt.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+ ") " ;
      this.deletionTab.push( inChain.length ) ;
    }*/

    if (elt!="") {
      this.input = this.input + " (" + elt+ ") " ;
      this.selectedParam = "" ;
      this.formulation.push( elt ) ;
      var inChain = " (" + elt+ ") " ;
      this.deletionTab.push( inChain.length ) ;
    }

  }


}